import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getAdyenLocationConfig = createSelector(creditCardsState, (cardsState) => cardsState.adyen.locationConfig);
